export const createTableObj = () => ({
  data: [],
  count: 0,
})

export const filterArrBySearchQuery = (arrToFilter, query) =>
  arrToFilter.filter(
    ({ name }) => name.toLowerCase().indexOf(query.toLowerCase()) >= 0,
  )

export const onSelectMenuOption = (
  item,
  { id, value = '' },
  isSelected,
  tmpItems,
  setTmpItems,
) => {
  if (isSelected) {
    const array = [...tmpItems]
    const index = array.indexOf(
      array.find(({ id: matchId, value: matchValue }) => {
        if (id) {
          return id === matchId
        }

        if (value) {
          return value === matchValue
        }

        return false
      }),
    )

    if (index > -1) {
      array.splice(index, 1)
    }

    setTmpItems(array)
  } else {
    setTmpItems([...tmpItems, item])
  }
}
